import { useSnackbar } from 'notistack';

const anchorOrigin = {
  horizontal: 'right',
  vertical: 'top'
};

export const useSnackbars = () => {
  let enqueueSnackbar;
  let closeSnackbar;

  try {
    const api = useSnackbar();
    enqueueSnackbar = api.enqueueSnackbar;
    closeSnackbar = api.closeSnackbar;
  } catch {
    // eslint-disable-next-line no-console
    console.log('%cuseSnackbar hook only inside SnackbarProvider', 'font-size: 16px; color: red;');
  }

  const buildOptions = (variant, opts) => ({
    anchorOrigin, // opts.anchorOrigin might override location
    ...opts,
    variant // can't be overridden
  });

  return {
    /* TODO
     we need possible to expose options (opts object) for autocomplete:
     native options: autoHideDuration, preventDuplicate, onClose, key, persist, anchorOrigin, style, className,
     custom options: link, onLinkClick, withCloseAction = true,
     */
    successSnackbar: (msg, opts = {}) => enqueueSnackbar?.(msg, buildOptions('success', opts)),
    errorSnackbar: (msg, opts = {}) => enqueueSnackbar?.(msg, buildOptions('error', opts)),
    infoSnackbar: (msg, opts = {}) => enqueueSnackbar?.(msg, buildOptions('info', opts)),
    warningSnackbar: (msg, opts = {}) => enqueueSnackbar?.(msg, buildOptions('warning', opts)),

    closeNotification: key => closeSnackbar?.(key),
    closeAllNotifications: () => closeSnackbar?.()
  };
};
